import { apiEndpoints } from "../../constants";
import { BaseService } from "./baseService";

class AffiliateServices extends BaseService {
  async getAffiliateByRefCode(code: string) {
    return this.get(`${apiEndpoints.AFFILIATE.GET_AFFILIATE}?ref=${code}`);
  }

  async createSaleProduct(data: IPaymentInfo) {
    return this.post(apiEndpoints.AFFILIATE.CREATE_SALE_PRODUCT, data);
  }
}

const affiliateServices = new AffiliateServices();
export default affiliateServices;
